import { useCloseToBottom } from '@/utils/hooks/useCloseToBottom'
import React, { useCallback } from 'react'

type Props = {
  className?: string,
  items: any[],
  itemsPerLoad: number,
  getComponent: (item: any) => JSX.Element
}

const LazyLoader = (props: Props) => {
  const [loadedItems, setLoadedItems] = React.useState<number>(props.itemsPerLoad)
  const ref = React.useRef<HTMLDivElement>(null)

  const addItems = useCallback(() => {
    setLoadedItems(loadedItems + props.itemsPerLoad)
  }, [loadedItems, props.itemsPerLoad])

  useCloseToBottom(ref, addItems)

  // reset loaded items when items change
  React.useEffect(() => {
    setLoadedItems(props.itemsPerLoad)
  }, [props.items, props.itemsPerLoad])

  return (
    <div ref={ref} className={props.className}>
      {props.items.slice(0, loadedItems).map((item) => props.getComponent(item))}
    </div>
  )
}

export default LazyLoader